import { render, staticRenderFns } from "./FuncionariosLista.vue?vue&type=template&id=45475bc7&"
import script from "./FuncionariosLista.vue?vue&type=script&lang=js&"
export * from "./FuncionariosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports